<script>
import _ from 'lodash'

export default {
  localStorage: {
    token: '',
  },

  methods: {
    getAvatarName(user) {
      let name = this.getFirstName(user)
      name = this.hasMoreThanOneWord(name) ? this.getFirstWord(name) : name

      return user?.nickname?.length ? user?.nickname : name
    },

    getFirstName(user) {
      return `${user?.displayname ?? ''}`.trim()
    },

    hasMoreThanOneWord(name) {
      return name.split(' ').length > 1
    },

    getFirstWord(name) {
      return _.first(name.split(' '))
    },

    getLastName(user) {
      return `${user?.familyname ?? ''}`
    },

    getShortenedName(user) {
      const name = user?.displayname ?? ''
      const lastName = user?.familyname ?? ''
      const email = user?.email ?? ''

      if (!name) return this.getTruncatedEmail(email)

      return `${this.getFirstWord(name)} ${this.getFirstWord(lastName)}`.trim()
    },

    getTruncatedEmail: function(email) {
      return `${email
        .split('')
        .slice(0, 8)
        .join('')}...`
    },

    getFullName(user) {
      if (!user) return ''

      const fullName = `${user?.displayname ?? ''} ${user?.familyname ??
        ''}`.trim()

      return fullName || (user?.email ?? '')
    },
  },
}
</script>
